import React from "react";
import { useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import { GoChevronRight } from "react-icons/go";
const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="volto-footer">
      <div className="volto-footer-banner">
        <Container>
          <div className="footer-banner-content">
            <img
              src="/images/footer-banner-logo.svg"
              alt="footer-logo-banner"
            />
            <div>
              <h4>Navigating Complexities</h4>
              <h6>Delivering Possibilities</h6>
            </div>
          </div>
        </Container>
      </div>
      <div className="volto-footer-row">
        <div className="volto-footer-menu-container">
          <Container>
            <Row>
              <Col lg={3} className="adjusted-col">
                <h4>COMPANY</h4>

                <ul>
                  <li>
                    <Link to={"/about#volto"}>
                      About Us{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/about#vision-mission"}>
                      Our Vision{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/about#vision-mission"}>
                      Our Mission{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/about#volto-way"}>
                      The Volto Way{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/about#leadership"}>
                      Leadership{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/about#ability"}>
                      Tech Ability{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/corp-social-responsibility"}>
                      CSR{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col lg={3}>
                <h4>INDUSTRIES</h4>

                <ul>
                  <li>
                    <Link to={"/industries/manufacturing"}>
                      Manufacturing{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/industries/hi-tech"}>
                      Hi-Tech{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/industries/life-science"}>
                      Life Science{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/industries/energy-utilities"}>
                      Energy & Utilities{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/industries/banking-and-finance"}>
                      Banking & Financial{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/industries/healthcare"}>
                      Health Care{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/industries/travel-and-hospitality"}>
                      Travel & Hospitality{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col lg={3}>
                <h4>SERVICES</h4>
                <ul>
                  <li>
                    <Link to={"/services/talent"}>
                      Talent Enablement{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/services/gcc-setup"}>
                      GCC Setup{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/services/executive-search"}>
                      Executive Search
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/services/training"}>
                      Corporate Training{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/services/nearshore"}>
                      Nearshore Services{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/services/sap-services"}>
                      SAP Services{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link to={"/services/digital-engineering"}>
                      Digital Engineering{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/services/ai-engineering"}>
                      AI & Automation{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/services/data-engineering"}>
                      Data Engineering{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/services/infrastructure-support"}>
                      Infrastructure Support{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/services/cloud-consulting"}>
                      Cloud Consulting{" "}
                      <span>
                        <GoChevronRight fontSize={26} />
                      </span>
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col lg={3}>
                <h4>SOCIAL MEDIA</h4>
                <ul>
                  <Link
                    className="social-media-icon"
                    to={"https://www.linkedin.com/company/volto-consulting/"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/images/linkedin.svg" alt="linkedin" />
                  </Link>
                  <Link
                    className="social-media-icon"
                    to={
                      "https://www.instagram.com/volto.consulting?igsh=MXB1aTRlMHNkMXYwNw=="
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/images/instagram.png" alt="instagram" />
                  </Link>
                  <Link
                    className="social-media-icon"
                    to={
                      "https://www.facebook.com/share/18xJ5zwQbm/?mibextid=wwXIfr"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/images/facebook.svg" alt="facebook" />
                  </Link>
                  {/* <Link
                    className="social-media-icon"
                    to={"https://www.youtube.com"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/images/youtube.svg" alt="youtube" />
                  </Link> */}
                </ul>
                <div className="volto-talk">
                  <h4 className="mb-2">US HEAD OFFICE</h4>
                  <h6>1750 E Golf Rd, Suite 224, Schaumburg, IL 60173  </h6>
                </div>
                <div className="volto-talk">
                  <h4 className="mb-2">INDIA HEAD OFFICE</h4>
                  <h6>
                    No.43/4, 1st Floor, Urban Vault Citrine, Sanjeevini Nagar,
                    Hebbal Village, Bellary Road, Bengaluru North, Bengaluru -
                    560092  
                  </h6>
                </div>
              </Col>
            </Row>
          </Container>
          <Container>
            <p className="volto-copy-rights">
              <span>2025 VOLTO, All Rights Reserved.</span>{" "}
              <span>
                <Link to={"/privacy-policy"}>
                  Privacy Policy & Terms and Conditions
                </Link>
              </span>
            </p>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Footer;
